import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


type Props = {
	text: string;
};

export default /*#__PURE__*/_defineComponent({
  props: {
    text: null
  },
  setup(__props: any) {

const props = __props as {
	text: string;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, _toDisplayString(props.text), 1))
}
}

})